import React from "react";

export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_intimacy-refined/artifacts/sr5lyegc_ChatGPT%20Image%20Apr%2020%2C%202026%2C%2012_45_29%20AM.png";

const SIZES = {
    xs: { h: 30, w: 82 },
    sm: { h: 42, w: 118 },
    md: { h: 60, w: 172 },
    lg: { h: 100, w: 272 },
    xl: { h: 150, w: 400 },
};

/**
 * Veloura brand mark. The asset is pink-on-cream; we render it inside a small
 * cream "plate" so it sits cleanly on our dark UI.
 * variant="plate"  → default. Pill with cream background.
 * variant="bare"   → raw <img>, useful in already-light regions.
 */
export default function Logo({
    size = "sm",
    variant = "plate",
    className = "",
    to,
    asLink,
    testId = "brand-logo",
    alt = "Veloura Wellness",
    dataCrop = true,
}) {
    const { h, w } = SIZES[size] || SIZES.sm;
    const imgStyle = {
        height: h,
        width: dataCrop ? w : "auto",
        objectFit: dataCrop ? "cover" : "contain",
        objectPosition: "center",
        display: "block",
        imageRendering: "auto",
    };
    const img = (
        <img
            src={LOGO_URL}
            alt={alt}
            height={h}
            width={dataCrop ? w : undefined}
            loading="eager"
            decoding="async"
            draggable={false}
            style={imgStyle}
        />
    );

    const content =
        variant === "plate" ? (
            <span
                className={`inline-flex items-center justify-center ${className}`}
                style={{
                    background: "#f2e3d3",
                    padding: "6px 10px",
                    borderRadius: 2,
                    boxShadow:
                        "inset 0 0 0 1px rgba(183,110,121,0.2), 0 6px 24px rgba(0,0,0,0.28)",
                }}
                data-testid={testId}
            >
                {img}
            </span>
        ) : (
            <span
                className={`inline-flex ${className}`}
                data-testid={testId}
            >
                {img}
            </span>
        );

    if (asLink) {
        const Link = asLink; // pass a component like RR <Link>
        return (
            <Link to={to || "/"} className="inline-flex">
                {content}
            </Link>
        );
    }
    return content;
}
